export const NOTIFICATION_GET_LIST = 'NOTIFICATION_GET_LIST';
export const NOTIFICATION_GET_LIST_SUCCESS = 'NOTIFICATION_GET_LIST_SUCCESS';
export const NOTIFICATION_GET_LIST_ERROR = 'NOTIFICATION_GET_LIST_ERROR';
export const NOTIFICATION_GET_LIST_WITH_FILTER = 'NOTIFICATION_GET_LIST_WITH_FILTER';
export const NOTIFICATION_GET_LIST_WITH_ORDER = 'NOTIFICATION_GET_LIST_WITH_ORDER';
export const NOTIFICATION_GET_LIST_SEARCH = 'NOTIFICATION_GET_LIST_SEARCH';


export const NOTIFICATION_DELETE_ITEMS = 'NOTIFICATION_DELETE_ITEMS';
export const NOTIFICATION_DELETE_ITEMS_SUCCESS = 'NOTIFICATION_DELETE_ITEMS_SUCCESS';
export const NOTIFICATION_DELETE_ITEMS_ERROR = 'NOTIFICATION_DELETE_ITEMS_ERROR';


export const NOTIFICATION_SELECTED_ITEMS_CHANGE = 'NOTIFICATION_SELECTED_ITEMS_CHANGE';
